import { useTranslation } from "react-i18next";
import { ConfigScreen } from "../screens/__generated__/ConfigsScreen_CreateMutation.graphql";

export type ScreenOrientation = "landscape" | "portrait";

export const isVerticalTemplate = (template: ConfigScreen) =>
  template === "vertical_stacked" ||
  template === "vertical_multi_day_schedule" ||
  template === "vertical_multi_row_schedule" ||
  template === "vertical_strength";

export const orientationForTemplate = (
  template: ConfigScreen,
): ScreenOrientation =>
  isVerticalTemplate(template) ? "portrait" : "landscape";

export const useReadableScreenTemplateName = () => {
  const { t } = useTranslation("ScreenTemplateNames");
  return (template: ConfigScreen) => {
    switch (template) {
      case "l_layout":
        return t("L shape with media");
      case "media_only":
        return t("Media only");
      case "schedule_only":
        return t("Schedule only");
      case "multi_day_schedule":
        return t("Multi day schedule");
      case "multi_column_schedule":
        return t("Multi column schedule");
      case "basic":
        return t("Basic");
      case "nutrition":
        return t("Nutrition");
      case "weather":
        return t("Weather");
      case "strength":
        return t("Strength");
      case "vertical_strength":
        return t("Vertical strength");
      case "vertical_stacked":
        return t("Vertical stacked");
      case "vertical_multi_day_schedule":
        return t("Vertical multi day schedule");
      case "vertical_multi_row_schedule":
        return t("Vertical multi row schedule");
      default:
        throw new Error(
          `readableTemplateName: Unexpected template ${template}`,
        );
    }
  };
};
